/* MAGAZINES — generated by mag-src/build-shopify.py. Do not edit.
   Byte-identical to the local page script except that the wrapper
   selector is [data-mg]: locally ONE div wraps every section, on the
   theme each section emits its own, and they are .tws-om / .tws-mg /
   .tws-mgo depending on the template. The attribute is the one hook
   that is the same on all three.

   ⚠ Every selector is document-wide (querySelectorAll), never rooted
   at a wrapper ELEMENT. Rooting at the page wrapper is what broke the
   Publishing Insights and Featured Writings filters: one wrapper
   locally, several on Shopify, so only the first section ever ran. */
/* Magazines — vanilla port of the handoff's DCLogic class, scoped to the page
   wrapper so the locked chrome and footer are untouched.

   NOT PORTED: _initRail (it drove #scrollRail, which lives in the handoff's own
   header — replaced here by the locked TWS chrome).

   ⚠ Boots directly, NOT inside requestAnimationFrame: rAF never fires in a
   backgrounded tab, which left an earlier page initialising nothing at all.
   ⚠ The reveal is never the only route to visible — anything already on screen
   is left alone, and a visibilitychange sweep reveals anything in view that the
   IntersectionObserver missed (IO does not deliver while a tab is hidden). */
(function () {
  if (window.__twsMgInit) return;
  window.__twsMgInit = true;
  var $$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KF = { rise: 'mgRise', riseS: 'mgRiseS', podium: 'mgPodium' };

  function splitWords() {
    $$('[data-mg] h1, [data-mg] section h2').forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      (function wrap(el) {
        Array.prototype.slice.call(el.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            if (!n.textContent.trim()) return;
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (p) {
              if (!p) return;
              if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
              var s = document.createElement('span'); s.className = 'sw';
              var i = document.createElement('i'); i.textContent = p;
              s.appendChild(i); frag.appendChild(s);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit') &&
                     !n.classList.contains('sw') && n.tagName !== 'svg' && n.tagName !== 'A') { wrap(n); }
        });
      })(h);
      var words = h.querySelectorAll('.sw');
      var fire = function () {
        words.forEach(function (w, i) { w.classList.add('on'); w.firstChild.style.animationDelay = (i * 52) + 'ms'; });
      };
      if (REDUCE || h.getBoundingClientRect().top < innerHeight * 0.9 ||
          typeof IntersectionObserver === 'undefined') { fire(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  function show(el) {
    var kind = KF[el.getAttribute('data-rv') || 'rise'] || 'mgRise';
    var d = parseInt(el.getAttribute('data-rv-d') || el.getAttribute('data-delay') || '0', 10);
    el.style.animation = kind + ' .82s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
    el.style.opacity = '';
  }

  function initReveal() {
    var els = $$('[data-mg] [data-rv]');
    if (!els.length || REDUCE || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > innerHeight * 0.88) { el.style.opacity = '0'; io.observe(el); }
    });
    function sweep() {
      els.forEach(function (el) {
        if (el.style.opacity !== '0') return;
        var b = el.getBoundingClientRect();
        if (b.top < innerHeight && b.bottom > 0) { show(el); io.unobserve(el); }
      });
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sweep(); });
    addEventListener('load', sweep);
  }

  function initRules() {
    var rules = $$('[data-mg] .rule');
    if (!rules.length || REDUCE || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.animation = 'mgRuleIn .9s cubic-bezier(.22,.7,.25,1) both';
        io.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    rules.forEach(function (r) { io.observe(r); });
  }

  function boot() { splitWords(); initReveal(); initRules(); }
  window.__twsMgBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* The theme editor replaces a section's HTML without reloading the
   page, so the reveal observer never sees the new nodes and they sit
   at opacity:0 — which reads as "the section is broken" to the user.
   boot() is idempotent (split headings carry data-split, and the
   reveal only touches elements still below the fold), so re-running it
   is safe. Live pages never fire this event. */
document.addEventListener('shopify:section:load', function () {
  if (window.__twsMgBoot) window.__twsMgBoot();
});
